import React, { Component } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  IconButton,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Stack,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import moment from "moment";

import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import TableViewIcon from "@mui/icons-material/TableView";
import CachedIcon from "@mui/icons-material/Cached";

import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import { AddCircleOutlined, ListAltOutlined } from "@mui/icons-material";
import { Calendar, KanbanIcon } from "lucide-react";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import AMCNewEntry from "./AMCNewEntry";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
const pieData = [
  { name: "Total Incomplete", value: 30, color: "#FFB020" },
  { name: "Total Submitted", value: 40, color: "#42A5F5" },
  { name: "Total Done", value: 50, color: "#66BB6A" },
  { name: "Total Lost", value: 20, color: "#EF5350" },
];
const liftServiceData = [
  { branch: "RAJ", total: 52, done: 38, pending: 26 },
  { branch: "BHV", total: 45, done: 30, pending: 18 },
  { branch: "SUR", total: 44, done: 28, pending: 17 },
];
const CallbackItem = ({ label, value, color, bg }) => (
  <Box
    sx={{
      background: "#fff",
      borderRadius: 2,
      p: 1.5,
      textAlign: "center",
      boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    }}
  >
    <Typography variant="caption" sx={{ fontWeight: 600 }}>
      {label}
    </Typography>

    <Typography variant="h5" fontWeight={700} mt={0.5}>
      {value}
    </Typography>

    <Box
      sx={{
        height: 6,
        borderRadius: 10,
        background: bg,
        mt: 1,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "70%",
          height: "100%",
          background: color,
          borderRadius: 10,
        }}
      />
    </Box>
  </Box>
);

const tableData = [
  {
    branch: "BHAVNAGAR",
    due: 110,
    pending: 50,
    submitted: 30,
    done: 25,
    lost: 5,
  },
  { branch: "RAJKOT", due: 90, pending: 40, submitted: 25, done: 20, lost: 5 },
  {
    branch: "BARODA",
    due: 150,
    pending: 60,
    submitted: 45,
    done: 35,
    lost: 10,
  },
  { branch: "SURAT", due: 125, pending: 55, submitted: 35, done: 30, lost: 5 },
];

class AMCDashboard extends Component {
  state = {
    formData: {
      dtpfromdate: get_30DaysBack_FromCurrentDate(new Date()),
      dtptodate: get_YMD_from_SYS(new Date()),
      dtpfromdateamc: get_30DaysBack_FromCurrentDate(new Date()),
      dtptodateamc: get_YMD_from_SYS(new Date()),
      branch: "BHV",
      dtpReceiptFrom: get_30DaysBack_FromCurrentDate(new Date()),
      dtpReceiptTo: get_YMD_from_SYS(new Date()),
      cmbReceiptBranch: "",
    },
    anchorElFilter: null,
    filterType: "All",
    renovationData: {
      incomplete: 60,
      submitted: 70,
      done: 120,
      lost: 47,
    },

    callbackData: {
      called: 120,
      techAssigned: 100,
      completed: 85,
      revisitCalled: 15,
      revisitTechAssigned: 10,
    },
    ARD: null,

    BranchList: [
      { label: "All", value: "All" },
      { label: "RAJ", value: "RAJ" },
      { label: "BHV", value: "BHV" },
      { label: "SUR", value: "SUR" },
    ],
    amcReceiptData: [
      { branch: "RAJ", amount: 8200 },
      { branch: "BHV", amount: 2100 },
      { branch: "SUR", amount: 4300 },
    ],
  };
  componentDidMount() {
    document.title = "Top India Elevator : AMC Dashboard";
    localStorage.setItem("Heading", "AMC Dashboard");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }
  getInfo = () => {
    document.getElementById("dtpfromdate")?.focus();
  };
  handleOnChange = (e) => {
    const { id, value } = e.target;

    this.setState({
      formData: {
        ...this.state.formData,
        [id]: value,
      },
    });
  };

  handleLoad = () => {
    if (this.validateDate()) {
    }
    // const { dtpfromdate, dtptodate } = this.state.formData;
    // console.log("LOAD AMC DATA", dtpfromdate, dtptodate);
  };
  handleLoadRenewal = () => {
    if (this.validateDateRenewal()) {
    }
    // const { dtpfromdate, dtptodate } = this.state.formData;
    // console.log("LOAD AMC DATA", dtpfromdate, dtptodate);
  };
  validateDate = () => {
    const { dtpfromdateamc, dtptodateamc } = this.state.formData;
    if (!dtpfromdateamc) {
      this.props.toastErrorMsg("Select From Date", "dtpfromdateamc");
      return false;
    }

    if (!dtptodateamc) {
      this.props.toastErrorMsg("Select To Date", "dtptodateamc");
      return false;
    }
    return true;
  };
  validateDateRenewal = () => {
    const { dtpfromdate, dtptodate } = this.state.formData;
    if (!dtpfromdate) {
      this.props.toastErrorMsg("Select From Date", "dtpfromdate");
      return false;
    }

    if (!dtptodate) {
      this.props.toastErrorMsg("Select To Date", "dtptodate");
      return false;
    }
    return true;
  };
  handleFilterOpen = (e) => {
    this.setState({ anchorElFilter: e.currentTarget });
  };

  handleFilterClose = () => {
    this.setState({ anchorElFilter: null });
  };

  handleFilterSelect = (type) => {
    if (type === "From Date - To Date") {
      document.getElementById("dtpfromdateamc")?.focus();
    }

    this.setState(
      {
        filterType: type,
        anchorElFilter: null,
      },
      () => {
        if (type === "From Date - To Date") {
          document.getElementById("dtpfromdateamc")?.focus();
        }
      },
    );
  };
  handleOnAMCEntryClick = () => {
    this.setState({ ARD: null }, () => {
      const ARD = (
        <AlertResponsiveDialog
          labelAgree=""
          labelDisagree="Close"
          alertMessage={<AMCNewEntry />}
          actionAlign="flex-end"
          handleOnClickNo={() => this.setState({ ARD: null })}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  handleCalendarView = () => {
    if (this.props.navigate) {
      this.props.navigate("/AMCCalendarView");
    }
  };

  handleKanbanView = () => {
    if (this.props.navigate) {
      this.props.navigate("/AMCKanbanView");
    }
  };

  render() {
    const todayLabel = moment().format("DD-MM-YYYY");
    const monthLabel = moment().format("MMMM YYYY");

    return (
      <form>
        {" "}
        <Box>
          <Box sx={{ display: "flex", gap: 3, p: 2, background: "#f5f7fa" }}>
            <Card sx={{ flex: 1, p: 2, borderRadius: 3 }}>
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <Typography variant="h5" fontWeight={700}>
                  AMC
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Tooltip title={"AMC Entry"} arrow>
                    <AddCircleOutlined
                      style={{
                        color: "#177cdd",
                      }}
                      className="addIcon"
                      onClick={this.handleOnAMCEntryClick}
                    />
                  </Tooltip>

                  <Tooltip title={"AMC List"} arrow>
                    <ListAltOutlined
                      className="ListIcon"
                      onClick={() => this.props.navigate("/AMCList")}
                    />
                  </Tooltip>

                  <Button
                    startIcon={<FilterAltOutlinedIcon />}
                    variant="outlined"
                    size="small"
                    sx={{ ml: 1 }}
                    onClick={this.handleFilterOpen}
                  >
                    Filter
                  </Button>
                </Box>
              </Box>
              <Menu
                anchorEl={this.state.anchorElFilter}
                open={Boolean(this.state.anchorElFilter)}
                onClose={this.handleFilterClose}
              >
                {["Today", "This Month", "From Date - To Date"].map((item) => (
                  <MenuItem
                    key={item}
                    onClick={() => this.handleFilterSelect(item)}
                  >
                    {item}
                  </MenuItem>
                ))}
              </Menu>
              <Grid container spacing={2} alignItems="flex-end" sx={{ mb: 2 }}>
                {this.state.filterType === "From Date - To Date" && (
                  <>
                    <Grid item>
                      <CtDtp
                        id="dtpfromdateamc"
                        value={this.state.formData.dtpfromdateamc}
                        label="From Date*"
                        handleOnChange={this.handleOnChange}
                        width={150}
                        maxLength={100}
                        nextCtrlID={"dtptodateamc"}
                        onKeyDown={this.props.onKeyDown}
                      />
                    </Grid>

                    <Grid item>
                      <CtDtp
                        id="dtptodateamc"
                        value={this.state.formData.dtptodateamc}
                        label="To Date*"
                        handleOnChange={this.handleOnChange}
                        width={150}
                        maxLength={100}
                        onKeyDown={this.props.onKeyDown}
                        defaultAction={this.handleLoad}
                      />
                    </Grid>

                    <Grid item>
                      <Button
                        variant="contained"
                        startIcon={<CachedIcon />}
                        sx={{ height: 40 }}
                        onClick={this.handleLoad}
                      >
                        LOAD
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
              {this.state.filterType === "Today" && (
                <Grid item>
                  <Typography fontWeight={600}>
                    Date: <span style={{ color: "#1976d2" }}>{todayLabel}</span>
                  </Typography>
                </Grid>
              )}

              {this.state.filterType === "This Month" && (
                <Grid item>
                  <Typography fontWeight={600}>
                    Month:{" "}
                    <span style={{ color: "#1976d2" }}>{monthLabel}</span>
                  </Typography>
                </Grid>
              )}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <PieChart width={260} height={260}>
                  <Pie
                    data={pieData}
                    innerRadius={60}
                    outerRadius={100}
                    dataKey="value"
                    onClick={() => this.props.navigate("/AMCList")}
                  >
                    {pieData.map((e, i) => (
                      <Cell key={i} fill={e.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>

                <Box>
                  {pieData.map((item, i) => (
                    <Box
                      key={i}
                      sx={{ display: "flex", alignItems: "center", mb: 1 }}
                    >
                      <Box
                        sx={{
                          width: 18,
                          height: 18,
                          background: item.color,
                          mr: 1,
                        }}
                      />
                      <Typography variant="body2">
                        {item.value} {item.name}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
              <Box
                sx={{
                  mt: 2,
                  p: 1.5,
                  background: "#eeeeee",
                  fontSize: "13px",
                  borderRadius: 1,
                }}
              >
                Clicking on this graph will navigate you through the AMC list,
                where the data will be filtered and displayed for the part of
                the graph you clicked on.
              </Box>
            </Card>

            <Card sx={{ flex: 1.3, p: 2, borderRadius: 3 }}>
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <Typography variant="h5" fontWeight={700}>
                  AMC Renewal
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Tooltip title={"AMC Renewal"} arrow>
                    <AddCircleOutlined
                      style={{
                        color: "#177cdd",
                      }}
                      className="addIcon"
                      onClick={() => this.props.navigate("/AMCRenewal")}
                    />
                  </Tooltip>

                  <Tooltip title={"AMC Renewal List"} arrow>
                    <ListAltOutlined
                      className="ListIcon"
                      onClick={() => this.props.navigate("/AMCRenewalList")}
                    />
                  </Tooltip>

                  <IconButton color="primary">
                    <TableViewIcon />
                  </IconButton>
                  <IconButton>
                    <Calendar onClick={this.handleCalendarView} />
                  </IconButton>
                  <IconButton>
                    <KanbanIcon onClick={this.handleKanbanView} />
                  </IconButton>
                </Box>
              </Box>

              {/* FILTERS */}
              <Grid container spacing={2} alignItems="flex-end" sx={{ mb: 2 }}>
                <Grid item>
                  <CtDtp
                    id="dtpfromdate"
                    value={this.state.formData.dtpfromdate}
                    label="From Date*"
                    handleOnChange={this.handleOnChange}
                    width={150}
                    maxLength={100}
                    nextCtrlID={"dtptodate"}
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>

                <Grid item>
                  <CtDtp
                    id="dtptodate"
                    value={this.state.formData.dtptodate}
                    label="To Date*"
                    handleOnChange={this.handleOnChange}
                    width={150}
                  />
                </Grid>

                <Grid item>
                  <Button
                    variant="contained"
                    startIcon={<CachedIcon />}
                    sx={{ height: 40 }}
                    onClick={this.handleLoadRenewal}
                  >
                    LOAD
                  </Button>
                </Grid>
              </Grid>

              {/* TABLE */}
              <Table>
                <TableHead>
                  <TableRow sx={{ background: "#0b5394" }}>
                    {[
                      "Branch",
                      "AMC Due",
                      "AMC Pending",
                      "Renewal Submitted",
                      "Renewal Done",
                      "Renewal Lost",
                    ].map((h, i) => (
                      <TableCell
                        key={i}
                        sx={{ color: "#fff", fontWeight: 600 }}
                      >
                        {h}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map((r, i) => (
                    <TableRow key={i}>
                      <TableCell>{r.branch}</TableCell>
                      <TableCell>{r.due}</TableCell>
                      <TableCell>{r.pending}</TableCell>
                      <TableCell>{r.submitted}</TableCell>
                      <TableCell>{r.done}</TableCell>
                      <TableCell>{r.lost}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Card>
          </Box>
          <Box sx={{ display: "flex", gap: 3, p: 2, background: "#f5f7fa" }}>
            <Card sx={{ flex: 1, p: 2, borderRadius: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 1.5,
                }}
              >
                <Typography variant="h6" fontWeight={700}>
                  Lift Service
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Tooltip title={"Lift Service Entry"} arrow>
                    <IconButton size="small">
                      <AddCircleOutlined sx={{ color: "#1f6de2" }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={"Lift Service List"} arrow>
                    <IconButton size="small">
                      <ListAltOutlined sx={{ color: "#5f6c7b" }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
              <Grid
                container
                spacing={1.5}
                alignItems="flex-end"
                sx={{ mb: 1 }}
              >
                <Grid item xs={12} sm="auto">
                  <CtDtp
                    id="dtpfromdateamc"
                    value={this.state.formData.dtpfromdateamc}
                    label="Service From Period*"
                    handleOnChange={this.handleOnChange}
                    width={160}
                    maxLength={100}
                    nextCtrlID={"dtptodateamc"}
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                <Grid item xs={12} sm="auto">
                  <CtDtp
                    id="dtptodateamc"
                    value={this.state.formData.dtptodateamc}
                    label="Service To Period*"
                    handleOnChange={this.handleOnChange}
                    width={160}
                    maxLength={100}
                    onKeyDown={this.props.onKeyDown}
                    defaultAction={this.handleLoad}
                  />
                </Grid>
                <Grid item xs={12} sm="auto">
                  <TextField
                    id="branch"
                    label="Branch*"
                    size="small"
                    select
                    value={this.state.formData.branch}
                    onChange={this.handleOnChange}
                    sx={{ minWidth: 110 }}
                  >
                    {["", "", ""].map((branch) => (
                      <MenuItem key={branch} value={branch}>
                        {branch}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm="auto">
                  <Button
                    variant="contained"
                    startIcon={<CachedIcon />}
                    sx={{ height: 40 }}
                    onClick={this.handleLoad}
                  >
                    LOAD
                  </Button>
                </Grid>
              </Grid>
              <Stack
                direction="row"
                spacing={2}
                sx={{ mb: 1, flexWrap: "wrap", rowGap: 1 }}
              >
                {[
                  ["Total Lift Service", "#4c6fff"],
                  ["Lift Service Done", "#63c76b"],
                  ["Lift Service Pending", "#f5c84c"],
                ].map(([label, color]) => (
                  <Box
                    key={label}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.8,
                      color: "#2d3748",
                      fontSize: 13,
                    }}
                  >
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        background: color,
                      }}
                    />
                    <Typography variant="caption" sx={{ fontWeight: 600 }}>
                      {label}
                    </Typography>
                  </Box>
                ))}
              </Stack>
              <Box sx={{ height: 230 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={liftServiceData}
                    barGap={6}
                    margin={{ top: 10, right: 20, left: -10, bottom: 0 }}
                  >
                    <CartesianGrid
                      vertical={false}
                      stroke="#e6e9ef"
                      strokeDasharray="4 4"
                    />
                    <XAxis
                      dataKey="branch"
                      tick={{ fontSize: 12, fill: "#7b8794" }}
                      axisLine={{ stroke: "#d9dee7" }}
                      tickLine={false}
                    />
                    <YAxis
                      tick={{ fontSize: 12, fill: "#7b8794" }}
                      axisLine={{ stroke: "#d9dee7" }}
                      tickLine={false}
                    />
                    <Bar dataKey="total" fill="#4c6fff" radius={[4, 4, 0, 0]} />
                    <Bar dataKey="done" fill="#63c76b" radius={[4, 4, 0, 0]} />
                    <Bar
                      dataKey="pending"
                      fill="#f5c84c"
                      radius={[4, 4, 0, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Box>
            </Card>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                flex: 1.3,
              }}
            >
              <Card sx={{ p: 2, borderRadius: 3 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography fontWeight={700}>Renovation Quotation</Typography>
                  <Button size="small" startIcon={<FilterAltOutlinedIcon />}>
                    Filter
                  </Button>
                </Box>

                {[
                  [
                    "Total Incomplete",
                    this.state.renovationData.incomplete,
                    "#e3f2fd",
                  ],
                  [
                    "Total Submitted",
                    this.state.renovationData.submitted,
                    "#e0f7fa",
                  ],
                  ["Total Done", this.state.renovationData.done, "#e8f5e9"],
                  ["Total Lost", this.state.renovationData.lost, "#ffebee"],
                ].map(([label, value, bg], i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      p: 1.2,
                      mt: 1,
                      borderRadius: 1,
                      background: bg,
                    }}
                  >
                    <Typography>{label}</Typography>
                    <Typography fontWeight={700}>{value}</Typography>
                  </Box>
                ))}
              </Card>
              <Card
                sx={{
                  p: 2,
                  borderRadius: 3,
                  background: "#f9fafb",
                }}
              >
                {/* HEADER */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Typography fontWeight={700}>Call Back</Typography>
                  <IconButton size="small">
                    <ListAltOutlined />
                  </IconButton>
                </Box>

                {/* CONTENT */}
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <CallbackItem
                      label="Called"
                      value={this.state.callbackData.called}
                      color="#42a5f5"
                      bg="#e3f2fd"
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <CallbackItem
                      label="Tech Assigned"
                      value={this.state.callbackData.techAssigned}
                      color="#66bb6a"
                      bg="#e8f5e9"
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <CallbackItem
                      label="Completed"
                      value={this.state.callbackData.completed}
                      color="#26a69a"
                      bg="#e0f2f1"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <CallbackItem
                      label="Re-visit Called"
                      value={this.state.callbackData.revisitCalled}
                      color="#ffa726"
                      bg="#fff3e0"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <CallbackItem
                      label="Re-visit Tech Assigned"
                      value={this.state.callbackData.revisitTechAssigned}
                      color="#ef5350"
                      bg="#ffebee"
                    />
                  </Grid>
                </Grid>
              </Card>
            </Box>
          </Box>
          <Card
            sx={{
              p: 2,
              borderRadius: 3,
              mt: 3,
              height: "500px",
              width: "550px",
            }}
          >
            {" "}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
            >
              <Typography variant="h6" fontWeight={700} mb={2}>
                Receipt
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Tooltip title={"Receipt Entry"} arrow>
                  <AddCircleOutlined
                    style={{
                      color: "#177cdd",
                    }}
                    className="addIcon"
                    onClick={() => this.props.navigate("/ReceiptEntry")}
                  />
                </Tooltip>

                <Tooltip title={"Receipt List"} arrow>
                  <ListAltOutlined
                    className="ListIcon"
                    onClick={() => this.props.navigate("/ReceiptList")}
                  />
                </Tooltip>
              </Box>
            </Box>
            {/* FILTER SECTION */}
            <Grid container spacing={2} alignItems="flex-end" mb={2}>
              <Grid item>
                <CtDtp
                  id="dtpReceiptFrom"
                  value={this.state.formData.dtpReceiptFrom}
                  label="From Date*"
                  handleOnChange={this.handleOnChange}
                  width={150}
                />
              </Grid>

              <Grid item>
                <CtDtp
                  id="dtpReceiptTo"
                  value={this.state.formData.dtpReceiptTo}
                  label="To Date*"
                  handleOnChange={this.handleOnChange}
                  width={150}
                />
              </Grid>

              <Grid item>
                <CtCmbEditable
                  id="cmbReceiptBranch"
                  label="Branch"
                  value={this.state.formData.cmbReceiptBranch}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  items={this.state.BranchList}
                  colID="value"
                />
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  startIcon={<CachedIcon />}
                  sx={{ height: 40 }}
                  onClick={this.handleLoadReceipt}
                >
                  LOAD
                </Button>
              </Grid>
            </Grid>
            {/* BAR CHART */}
            <Box sx={{ height: 280 }}>
              <ResponsiveContainer>
                <BarChart
                  width={420}
                  height={250}
                  data={this.state.amcReceiptData}
                  barSize={45}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="branch" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="amount" fill="#1565c0" radius={[6, 6, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </Box>
          </Card>
        </Box>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCDashboard {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(WithNavigate)));
